import React, { useContext, useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { AuthContext } from "../contexts/AuthContext.js";
import { loginAPI } from "../apis/apiAuth.js";
import { Link, useNavigate  } from "react-router-dom";
import * as Yup from "yup";
import "../styles/CreateAccount.css";
import { Eye, EyeOff } from "lucide-react";

const LoginSchema = Yup.object().shape({
  mail: Yup.string()
    .email('Mail invalide')
    .required('Mail requis')
    .max(100, 'Abuse pas'),
  password: Yup.string()
    .min(8, 'Le mot de passe doit contenir au moins 8 caractères')
    .matches(
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/, 
      'Le mot de passe doit contenir au moins une majuscule, une minuscule, un chiffre et un caractère spécial'
    )
    .required('Mot de passe requis')
});

const LoginPage = () => {
    const authCtx = useContext(AuthContext);
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = async (values) => {
        try {
            const loginRes = await loginAPI(values.mail, values.password);
            console.log('Login Response:', loginRes);
            
            if (loginRes.message || loginRes.Message) {
                console.log('Oups...', loginRes.message || loginRes.Message);
            } else {
                const userInitialized = await authCtx.initUser(
                    loginRes.IdToken,
                    loginRes.idUser
                );

                if (userInitialized) {
                    authCtx.login(
                        loginRes.IdToken,
                        loginRes.idUser,
                        loginRes.RefreshToken
                    );
                    localStorage.removeItem('shippingAddress');
                    navigate("/account");
                } else {
                    console.log("Échec de l'initialisation de l'utilisateur");
                }
            }
        } catch (error) {
            console.log('Login error', error);
        }
    };

    return (
        <div className="form-container">
            <h1>Connexion à Baltee</h1>
            <p>
                Accédez à votre compte Baltee. <br />
                Vous n'avez pas encore de compte ? <Link to="/create-account">Inscrivez-vous ↗</Link>
            </p>
            <Formik
                initialValues={{
                    mail: '',
                    password: ''
                }}
                validationSchema={LoginSchema}
                onSubmit={(values, { setSubmitting }) => {
                    handleSubmit(values);
                    setSubmitting(false);
                }}
            >
                {({ isSubmitting }) => (
                    <Form className="apple-form">
                        <div className="form-group">
                            <Field type="email" name="mail" placeholder="nom@example.com" />
                            <ErrorMessage name="mail" component="div" className="error" />
                        </div>
                        <div className="form-group password-field" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                            <Field 
                                type={showPassword ? "text" : "password"} 
                                name="password" 
                                placeholder="Mot de passe" 
                                style={{ flex: 1, paddingRight: '2.5rem' }}
                            />
                            <button 
                                type="button" 
                                className="eye-icon" 
                                onClick={togglePasswordVisibility} 
                                style={{ 
                                    position: 'absolute', 
                                    right: '10px', 
                                    background: 'none', 
                                    border: 'none', 
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    top: '5px'
                                }}
                            >
                                {showPassword ? <EyeOff /> : <Eye />}
                            </button>
                        </div>
                        <ErrorMessage name="password" component="div" className="error" style={{ marginTop: '5px' }} />
                        <button type="submit" className="submit-button" disabled={isSubmitting}>
                            {isSubmitting ? "Chargement..." : "Se connecter"}
                        </button>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default LoginPage;
